var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platParent",style:({ backgroundColor: _vm.bgColor })},[_c('title-widge',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle,"titleColor":_vm.titleColor,"prevImg":_vm.prevImg,"nextImg":_vm.nextImg}}),_c('div',{staticClass:"divImg"},_vm._l((_vm.items),function(item,index){return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({
      src:item,
      loading: require('./../../../../../assets/wheelplanting.jpg'),
    }),expression:"{\n      src:item,\n      loading: require('./../../../../../assets/wheelplanting.jpg'),\n    }"}],key:index})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }